export default "__VITE_ASSET__h5U$68HM__"